import Config from '@app/dev/config/main';
import { PhoneFields } from '@app/dev/terminal/components/requestPayoutPopup/components/phoneFields';

const { registrationFormFiledConfigs } = Config.registrationFormConfigs;

export const contactFields = [
  {
    name: 'email',
    fieldName: 'Email',
    enabled: registrationFormFiledConfigs.email,
    errorMessage: 'Name is not valid',
  },
  {
    name: 'phoneNumber',
    fieldName: 'Phone Number',
    enabled: registrationFormFiledConfigs.phoneNumber,
    className: 'phone-section',
    custumViewComponent: PhoneFields,
    errorMessage: 'Last Name is not valid',
  },
  {
    name: 'street',
    fieldName: 'Street',
    enabled: registrationFormFiledConfigs.street,
    className: 'contacts-section',
    errorMessage: 'Email is not valid',
  },
  {
    name: 'city',
    fieldName: 'City',
    enabled: registrationFormFiledConfigs.city,
    className: 'contacts-section',
    errorMessage: 'Field is required',
  },
  {
    name: 'zipCode',
    fieldName: 'Zip-Code',
    enabled: registrationFormFiledConfigs.zipCode,
    className: 'contacts-section',
    errorMessage: 'Field is required',
  },
];
